import React from 'react';
import Avatar from '../../../components/common/avatars';
import logo from '../../../assets/images/logo-converge.svg';
import { StrongSubtitle } from '../../../components/common/Title';
import GroupIcon from '@material-ui/icons/Group';
import EditIcon from '@material-ui/icons/Edit';
import { Tooltip } from '@material-ui/core';

const STATUS_COPY = {
  draft: { label: 'Borrador', color: '#795548', background: '#efebe9' },
  archived: { label: 'Archivada', color: '#607d8b', background: '#eceff1' },
  upcoming: { label: 'Próximamente', color: '#38bdf8', background: 'rgba(56, 189, 248, 0.12)' },
  active: { label: 'Abierta', color: '#43a047', background: 'rgba(67, 160, 71, 0.15)' },
  closed: { label: 'Finalizada', color: '#607d8b', background: 'rgba(96, 125, 139, 0.18)' },
};

const formatDate = (value) => {
  if (!value) return '-';
  return new Date(value).toLocaleString('es-CL', {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
};

const ConvocatoriaCard = ({ convocatoria, onViewApplications, onEdit }) => {
  const { id, title, starts_at, ends_at, created_at, updated_at } = convocatoria;
  const now = new Date();
  const startDate = starts_at ? new Date(starts_at) : null;
  const endDate = ends_at ? new Date(ends_at) : null;

  let statusKey = 'upcoming';
  if (startDate && endDate) {
    if (now < startDate) {
      statusKey = 'upcoming';
    } else if (now > endDate) {
      statusKey = 'closed';
    } else {
      statusKey = 'active';
    }
  }

  if (convocatoria.status === 'draft' || convocatoria.status === 'archived') {
    statusKey = convocatoria.status;
  } else if (convocatoria.status === 'closed') {
    statusKey = 'closed';
  }

  const { label, color, background } = STATUS_COPY[statusKey];

  return (
    <article className="convocatoria-card news__card">
      <div className="news-heading">
        <div className="title-section">
          <Avatar image={/^https?:\/\//i.test(convocatoria.branding?.logo_url || '') ? convocatoria.branding.logo_url : logo} variant="extra-small" />
          <div className="convocatoria-card__title">
            <div className="convocatoria-card__title-row">
              <StrongSubtitle text={title} />
              <span
                className="convocatoria-card__status"
                style={{ color, backgroundColor: background }}
              >
                {label}
              </span>
            </div>
            <span className="convocatoria-card__id">{convocatoria.slug || id}</span>
          </div>
        </div>
        <div className="convocatoria-card__actions">
          <Tooltip title="Ver postulaciones" placement="left" arrow>
            <button type="button" className="convocatoria-card__icon" onClick={onViewApplications} aria-label={`Ver postulaciones de ${title}`}>
              <GroupIcon />
            </button>
          </Tooltip>
          <Tooltip title="Editar premio" placement="left" arrow>
            <button type="button" className="convocatoria-card__icon" onClick={onEdit} aria-label={`Editar premio ${title}`}>
              <EditIcon />
            </button>
          </Tooltip>
        </div>
      </div>
      <div className="convocatoria-card__body">
        <div>
          <span className="convocatoria-card__label">Comienza</span>
          <span className="convocatoria-card__value">{formatDate(starts_at)}</span>
        </div>
        <div>
          <span className="convocatoria-card__label">Termina</span>
          <span className="convocatoria-card__value">{formatDate(ends_at)}</span>
        </div>
        <div>
          <span className="convocatoria-card__label">Creada el</span>
          <span className="convocatoria-card__value">{formatDate(created_at)}</span>
        </div>
        <div>
          <span className="convocatoria-card__label">Actualizada el</span>
          <span className="convocatoria-card__value">{formatDate(updated_at)}</span>
        </div>
      </div>
    </article>
  );
};

export default ConvocatoriaCard;
